// src/pages/transactions/TransactionFormSkeleton.jsx
import React from "react";

const SkeletonField = () => (
  <div className="skeleton-field">
    <div className="skeleton skeleton-label" />
    <div className="skeleton skeleton-input" />
  </div>
);

export default function TransactionFormSkeleton() {
  return (
    <>
      <div className="card">
        <div className="skeleton skeleton-title" />
        <div className="grid">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <SkeletonField key={i} />
          ))}
        </div>
      </div>

      <div className="card">
        <div className="skeleton skeleton-title" />
        <div className="skeleton skeleton-input" style={{ height: 48 }} />
      </div>

      <style>{`
        .skeleton {
          background: linear-gradient(
            90deg,
            var(--border) 25%,
            var(--border-strong) 50%,
            var(--border) 75%
          );
          background-size: 200% 100%;
          animation: skeleton-shimmer 1.4s ease-in-out infinite;
          border-radius: 8px;
        }
        @keyframes skeleton-shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
        .skeleton-title {
          height: 22px;
          width: 40%;
          margin-bottom: 20px;
        }
        .skeleton-field {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        .skeleton-label {
          height: 13px;
          width: 40%;
        }
        .skeleton-input {
          height: 42px;
          width: 100%;
          border-radius: 10px;
        }
      `}</style>
    </>
  );
}